import { commonMessages } from '../../../../util/messages'

export const maturityCompliancesRulesMessages = {
  common: commonMessages,
  create: {
    success: 'Maturity compliance rule successfully crated',
    error: 'Error creating maturity compliance rule',
  },
  update: {
    success: 'Maturity compliance rule successfully updated',
    error: 'Error updating maturity compliance rule',
  },
  delete: {
    success: 'Maturity compliance rule successfully deleted',
    error: 'Error deleting maturity compliance rule',
  },
}
